import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgService32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path fill="currentColor" fillRule="evenodd" d="m28 28-5.55-1.88A11.945 11.945 0 0 1 16 28C9.37 28 4 22.63 4 16S9.37 4 16 4s12 5.37 12 12c0 2.38-.69 4.59-1.88 6.45zm-1-12c0-6.08-4.92-11-11-11S5 9.92 5 16s4.92 11 11 11c2.18 0 4.21-.63 5.91-1.72.26-.16.57-.2.86-.1l3.63 1.23-1.23-3.63c-.1-.29-.06-.6.1-.86 1.09-1.71 1.72-3.74 1.72-5.91zm-11 6c-.55 0-1-.45-1-1v-6c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1m0-10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1" clipRule="evenodd" /></SvgIcon>;
};
const Memo = memo(SvgService32);
export default Memo;